'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _lodash = require('lodash.clonedeep');

var _lodash2 = _interopRequireDefault(_lodash);

var _redux = require('redux');

var _media = require('../actions/media');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DEFAULT_FILTER = {
    date: [],
    type: '全部',
    keyword: ''
};
var filter = function filter() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_FILTER;
    var action = arguments[1];

    switch (action.type) {
        case _media.FILTER_MEDIA:
            return Object.assign({}, state, action.filter);
        default:
            return state;
    }
};

var INITIAL_STATE = {
    isFetching: false,
    didInvalidate: false,
    items: [],
    pagination: {
        per_page: 20,
        total: 0
    }
};
var media = function media() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : INITIAL_STATE;
    var action = arguments[1];

    switch (action.type) {
        case _media.INVALIDATE_MEDIA:
            return _extends({}, state, {
                didInvalidate: true
            });
        case _media.REQUEST_MEDIA:
            return _extends({}, state, {
                isFetching: true,
                didInvalidate: false
            });
        case _media.RECEIVE_MEDIA:
            return _extends({}, state, {
                isFetching: false,
                didInvalidate: false,
                items: action.media,
                pagination: action.pagination,
                lastUpdated: action.received_at
            });
        case _media.FAILURE_MEDIA:
            return _extends({}, state, {
                isFetching: false,
                didInvalidate: false,
                error: action.error
            });
        case _media.POST_MEDIA_REQUEST:
            return _extends({}, state, {
                isPosting: true
            });
        case _media.POST_MEDIA_SUCCESS:
            return _extends({}, state, {
                isPosting: false,
                didInvalidate: true
            });
        case _media.POST_MEDIA_FAILURE:
            return _extends({}, state, {
                isPosting: false,
                didInvalidate: true
            });
        default:
            return state;
    }
};

var mediaReducer = (0, _redux.combineReducers)({
    media: media,
    filter: filter
});

exports.default = mediaReducer;


//////////////////
// WEBPACK FOOTER
// ./src/js/reducers/media.js
// module id = 901
// module chunks = 0